import * as dashbaordTypes from "../../types/admin/dashbaordTypes";

export const addDashboardWidgetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case dashbaordTypes.ADD_DASHBOARD_WIDGET_REQUEST:
      return {
        ...state,
        loadings: true,
      };
    case dashbaordTypes.ADD_DASHBOARD_WIDGET_SUCCESS:
      return {
        ...state,
        loadings: false,
        addDashboardWidgetList: payload,
        errors: "",
      };
    case dashbaordTypes.ADD_DASHBOARD_WIDGET_FAIL:
      return {
        ...state,
        loadings: false,
        errors: payload,
        addDashboardWidgetList: [],
      };
    default:
      return state;
  }
};

export const getDashboardWidgetReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case dashbaordTypes.GET_DASHBOARD_WIDGET_REQUEST:
      return {
        ...state,
        loadings: true,
      };
    case dashbaordTypes.GET_DASHBOARD_WIDGET_SUCCESS:
      return {
        ...state,
        loadings: false,
        getDashboardWidgetInfo: payload,
        errors: "",
      };
    case dashbaordTypes.GET_DASHBOARD_WIDGET_FAIL:
      return {
        ...state,
        loadings: false,
        errors: payload,
        getDashboardWidgetInfo: {},
      };
    default:
      return state;
  }
};

export const getActivityOverviewReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case dashbaordTypes.GET_ACTIVITY_OVERVIEW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case dashbaordTypes.GET_ACTIVITY_OVERVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case dashbaordTypes.GET_ACTIVITY_OVERVIEW_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: {},
      };
    default:
      return state;
  }
};

export const getDashboardRecruitmentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case dashbaordTypes.GET_DASHBOARD_RECRUITMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case dashbaordTypes.GET_DASHBOARD_RECRUITMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        errors: "",
      };
    case dashbaordTypes.GET_DASHBOARD_RECRUITMENT_FAIL:
      return {
        ...state,
        loading: false,
        errors: payload,
        info: {},
      };
    default:
      return state;
  }
};
